<template>
  <div>
    <a-form :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标签名称">
            <a-input v-model="searchForm.label_name" allowClear placeholder="请输入标签名称" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" option-filter-prop="children" placeholder="请选择发布平台" allowClear show-search>
              <a-select-option v-for="item in optionsList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.status" allowClear show-search option-filter-prop="children" placeholder="请选择状态" style="width: 100%">
              <a-select-option v-for="item in LABEL_STATUS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="是否有上架文章">
            <a-select v-model="searchForm.is_article" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
              <a-select-option v-for="item in is_article" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAddTag">添加标签</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :columns="columns" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="article_total" slot-scope="text, record">
        <a-button size="small" type="link" @click="searchArticle(record.id)">{{ text }}</a-button>
      </template><template slot="status" slot-scope="text">
        <span v-if="text === 1" color="green">启用</span>
        <span v-else style="color:red;">禁用</span>
      </template>
      <template slot="module" slot-scope="text">
        <span v-if="text === 1">文章</span>
        <span v-else>帖子</span>
      </template>
      <template slot="name9" slot-scope="text, record">
        <div class="flex-sb">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" v-if="record.status === 1" @click="handleTableCommand('status', record)">禁用</a-button>
          <a-button size="small" type="link" v-else @click="handleTableCommand('status', record)">启用</a-button>
          <a-button size="small" type="link" @click="handleTableCommand('delete',record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 编辑标签 -->
    <a-modal v-model="visible" :title="title" :afterClose="handleCancel" width="520px">
      <a-form-model ref="formDom" :rules="rules" :model="form" :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-form-model-item label="发布平台" prop="line_id">
          <!-- <a-select v-model="form.line_id" allowClear option-filter-prop="children" show-search placeholder="请输入">
            <a-select-option v-for="item in options" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
          </a-select> -->
          <a-cascader v-model="lines_id" popupClassName="org" :options="options" change-on-select placeholder="请选择" @change="orgChange" />
        </a-form-model-item>
        <a-form-model-item label="标签名称" prop="label_name">
          <a-input v-model.trim="form.label_name" :maxLength="32" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="声母" prop="initial_consonant">
          <a-input v-model.trim="form.initial_consonant" @change="onChange" :maxLength="32" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="标签描述" prop="describe">
          <a-input v-model.trim="form.describe" :maxLength="100" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="模块类型" prop="module">
          <a-radio-group v-model="form.module" allowClear show-search placeholder="请选择">
            <a-radio v-for="(item, index) in LABEL_MODULE" :key="item.key" :value="item.key">{{ item.value }}<span v-if="index===1"> (仅限用于集团内站)</span></a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="推荐" prop="is_recommend">
          <a-radio-group v-model="form.is_recommend">
            <a-radio v-for="item in ARTICLE_ISCOMMEND" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="置顶" prop="is_top">
          <a-radio-group v-model="form.is_top">
            <a-radio v-for="item in ARTICLE_IS_TOP" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取 消
        </a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleSubmit">
          提 交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { strategyCommand, title } from './business/tableLogic'
import { searchForm, columns, rules, form } from './business/tagList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'
import { start } from 'nprogress'

export default {
  setup() {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息

    const state = reactive({
      rules,
      columns, // 表头列表
      options: [], // 业务线
      cascader: [], // 级联选择-搜索
      btnLoading: false, // 按钮loading
      title: title.Add, // 弹窗title
      form: { ...form },
      searchForm: { ...searchForm }, // 搜索表单
      optionsList: [], // 业务线接口数据
      lines_id: [],
      is_article: [
        { key: 2, value: '否' },
        { key: 1, value: '是' }
      ]
    })

    onMounted(() => {
      methods.getList()
      methods.getPlatform()
    })

    const methods = {
      // 通过标签ID搜索文章
      searchArticle(id) {
        this.$router.push(`/article/list?id=${id}`)
      },
      orgChange(val) {
        state.form.line_id = val[val.length - 1]
      },

      // 声母过滤,只能输入大小写字母
      onChange(e) {
        state.form.initial_consonant = e.target.value.replace(/[^a-z]/gi, '')
      },

      search() {
        _this.pagination.current = 1
        this.getList()
      },

      // 获取列表
      async getList() {
        _this.loading = true
        const res = await api.listLabel({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { label, pagination } = res.data
        _this.data = label
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.optionsList = res.data
        res.data.filter(item => {
          if (item.parent_id === 0) {
            const params = {
              value: parseInt(item.id),
              label: item.name
            }
            state.options.push(params)
          }
        })
        state.options.map(item => {
          this.getDepartmentTree(res.data, item)
        })
      },
      // 过滤平台列表
      getDepartmentTree(originList, listItem) {
        const hasChildren = originList.every(item => listItem.value !== item.parent_id)
        if (!hasChildren) {
          listItem.children = []
        } else {
          return false
        }
        originList.map(item => {
          if (listItem.value === item.parent_id) {
            const params = {
              value: parseInt(item.id),
              label: item.name,
              name: item.name
            }
            listItem.children.push(params)
            this.getDepartmentTree(originList, params)
          }
        })
      },

      // 新增标签
      handleAddTag() {
        _this.visible = true
        _this.isEdit = false
        state.title = title.Add
      },

      // 关闭弹窗
      handleCancel() {
        state.lines_id = []
        _this.visible = false
        _this.$refs.formDom.resetFields()
      },

      // 提交编辑
      handleSubmit() {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            const arr = await Promise.all([api.forbiddenWordsArticle({ content: state.form.label_name, module: 2 })])
            if (/#F00/g.test(arr[0].data.content)) {
              _this.$confirm({
                content: '存在为违禁词,请确认是否提交？',
                async onOk() {
                  _this.submit()
                }
              })
            } else {
              _this.submit()
            }
          }
        })
      },

      async submit() {
        state.btnLoading = true
        let res
        if (_this.isEdit) {
          res = await api.updateArticleLabel(state.form)
        } else {
          res = await api.createLabel(state.form)
        }
        if (_this.$validate(res)) {
          this.$message.success(_this.isEdit ? '编辑成功~' : '新增成功~')
          this.getList()
          _this.visible = false
        }
        state.btnLoading = false
      },

      // 清除
      handleClear() {
        state.searchForm = { ...searchForm }
        state.cascader = []
        this.search()
      },

      // 表格操作
      handleTableCommand(type, data) {
        strategyCommand[type].call(_this, data)
        state.optionsList.find(item => {
          if (parseInt(item.id) === data.line_id) {
            item.parent_id === 0
              ? state.lines_id.push(parseInt(item.id))
              : state.lines_id.push(item.parent_id) && state.lines_id.push(parseInt(item.id))
            state.optionsList.find(items => {
              if (items.parent_id !== 0 && parseInt(items.id) === item.parent_id) {
                state.lines_id.unshift(items.parent_id)
              }
            })
          }
        })
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-tag {
  margin-right: 0;
}
.status {
  color: #52c41a;
  border-color: #b7eb8f;
}
.nostatus {
  color: #f7b500;
  border-color: #f7b500;
}
/deep/ .ant-cascader-menus ul,
.ant-cascader-menus ol {
  overflow: hidden !important;
}
.org {
  color: #000;
}
</style>
